import { behaviorActionTypes } from '../constants/ApiConstants';

const initialState = {
  masterData: null,
  behaviorList: null,
  behaviorDetail: null,
  saved_behavior: null,
  deleted_behavior: null,
  behaviorCollactDataListByBehaviorId: null,
  deleted_behaviorCollactData: null,
  behaviourReductionSingleGraphData: null,
  updatedCollectedBehaviorDataStatus: null,
  saved_rawbehaviordata: null,
  save_copyPatientBehaviorReduction : null,
  patientBehaviorsReductionForDailySummary:null
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case behaviorActionTypes.get_masterData.REQUEST:
      return {
        ...state,
        loading: true,
        masterData: null,
      };
    case behaviorActionTypes.get_masterData.SUCCESS:
      return {
        ...state,
        loading: false,
        masterData: payload,
      };
    case behaviorActionTypes.save_behavior.REQUEST:
      return {
        ...state,
        loading: true,
        saved_behavior: null,
      };
    case behaviorActionTypes.save_behavior.SUCCESS:
      return {
        ...state,
        loading: false,
        saved_behavior: payload,
      };
    case behaviorActionTypes.get_behaviorList.REQUEST:
      return {
        ...state,
        loading: true,
        behaviorList: null,
      };
    case behaviorActionTypes.get_behaviorList.SUCCESS:
      return {
        ...state,
        loading: false,
        behaviorList: payload,
      };
    case behaviorActionTypes.get_behaviorDetail.REQUEST:
      return {
        ...state,
        loading: true,
        behaviorDetail: null,
      };
    case behaviorActionTypes.get_behaviorDetail.SUCCESS:
      return {
        ...state,
        loading: false,
        behaviorDetail: payload,
      };
    case behaviorActionTypes.delete_behavior.REQUEST:
      return {
        ...state,
        loading: true,
        deleted_behavior: null,
      };
    case behaviorActionTypes.delete_behavior.SUCCESS:
      return {
        ...state,
        loading: false,
        deleted_behavior: payload,
      };
    case behaviorActionTypes.get_behaviorCollactDataListByBehaviorId.REQUEST:
      return {
        ...state,
        loading: true,
        behaviorCollactDataListByBehaviorId: null,
      };
    case behaviorActionTypes.get_behaviorCollactDataListByBehaviorId.SUCCESS:
      return {
        ...state,
        loading: false,
        behaviorCollactDataListByBehaviorId: payload,
      };
    case behaviorActionTypes.delete_behaviorCollactData.REQUEST:
      return {
        ...state,
        loading: true,
        deleted_behaviorCollactData: null,
      };
    case behaviorActionTypes.delete_behaviorCollactData.SUCCESS:
      return {
        ...state,
        loading: false,
        deleted_behaviorCollactData: payload,
      };
    case behaviorActionTypes.get_behaviourReductionSingleGraph.REQUEST:
      return {
        ...state,
        loading: true,
        behaviourReductionSingleGraphData: null,
      };
    case behaviorActionTypes.get_behaviourReductionSingleGraph.SUCCESS:
      return {
        ...state,
        loading: false,
        behaviourReductionSingleGraphData: payload,
      };
    case behaviorActionTypes.update_collectedBehaviorDataStatus.REQUEST:
      return {
        ...state,
        loading: true,
        updatedCollectedBehaviorDataStatus: null,
      };
    case behaviorActionTypes.update_collectedBehaviorDataStatus.SUCCESS:
      return {
        ...state,
        loading: false,
        updatedCollectedBehaviorDataStatus: payload,
      };
    case behaviorActionTypes.save_rawbehaviordata.REQUEST:
      return {
        ...state,
        loading: true,
        saved_rawbehaviordata: null,
      };
    case behaviorActionTypes.save_rawbehaviordata.SUCCESS:
      return {
        ...state,
        loading: false,
        saved_rawbehaviordata: payload,
      };
      case behaviorActionTypes.save_copyPatientBehaviorReduction.REQUEST:
        return {
          ...state,
          loading: true,
          save_copyPatientBehaviorReduction: null,
        };
    case behaviorActionTypes.save_copyPatientBehaviorReduction.SUCCESS:
        return {
          ...state,
          loading: false,
          save_copyPatientBehaviorReduction: payload,
        };
        case behaviorActionTypes.get_patientBehaviors_reduction_for_dailySummary.REQUEST:
      return {
        ...state,
        loading: true,
        patientBehaviorsReductionForDailySummary: null,
      };
    case behaviorActionTypes.get_patientBehaviors_reduction_for_dailySummary.SUCCESS:
      return {
        ...state,
        loading: false,
        patientBehaviorsReductionForDailySummary: payload,
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/modules/patients/components/DataCollection/BehaviorReductiom/Behavior/reducers/behaviorReducer.js